import { render, staticRenderFns } from "./index.vue?vue&type=template&id=88fa1e82&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/hamzakambaza/Desktop/Sites/soirs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('88fa1e82')) {
      api.createRecord('88fa1e82', component.options)
    } else {
      api.reload('88fa1e82', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=88fa1e82&", function () {
      api.rerender('88fa1e82', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/virtual-account/index.vue"
export default component.exports